import { Context } from "csi/def/Context";
import Spec from "csi/heading/Spec";
import declare from "dojo/_base/declare";
import { C8Node } from "src/c8-platform/type/node";
import ParameterValueRefmapMatrix from "./ParameterValueRefmapMatrix";

const FlatIngredientItemComplianceAnalysisFunctionsMatrix = declare(ParameterValueRefmapMatrix, {
	/**
	 * @override
     * C8FB-3478
	 * Grey out cells without a ProductComplianceAnalysisType configured for the BaseProduct Type in that column
     * This is with specific consideration of FlatIngredientItems
	 */
	_getSpecNodes(ctx: Context, spec: Spec, nodes: C8Node[]): C8Node[] {
		const flatIngNode = ctx.getNode();
		const fldsRevNode = ctx.cache.getNode(flatIngNode.__Parent__);
		const parentProductNode = ctx.cache.getNode(fldsRevNode.ParentProduct);
		if (!this._hasComplianceAnalysisTypes(ctx, parentProductNode, spec)) {
			ctx.setReadOnly(true);
		}
		return this.inherited<C8Node[]>(arguments);
	},
});

export = FlatIngredientItemComplianceAnalysisFunctionsMatrix;